import { useSearchParams } from 'next/navigation';
import { useCallback } from 'react';
import CustomConfigs from '~/constants/customConfigs';
import { useEventCorrelationId } from '~/context/common/StaticContext';
import BrowserCookies from '~/utilities/BrowserCookies';

// Console-logs deferred stream resolutions on the client, but only when the
// merch-enable-debug flag is present via the URL or the merch-enable-debug
// cookie. No-ops otherwise.
export function useDeferredStreamDebugLogger() {
  const eventCorrelationId = useEventCorrelationId();
  const searchParams = useSearchParams();
  const isDebugEnabled =
    (searchParams?.has(CustomConfigs.EnableDebug) ?? false) ||
    BrowserCookies.get(CustomConfigs.EnableDebug) !== undefined;

  return useCallback(
    <T>(location: string, data: T) => {
      if (!isDebugEnabled) return;

      console.log(
        `[debug] ${
          data === undefined ? '[X] DEGRADED' : '[✓] Resolved'
        } deferred stream on client: ${location}`,
        {
          data,
          eventCorrelationId
        }
      );
    },
    [eventCorrelationId, isDebugEnabled]
  );
}
